import { Link } from 'react-router-dom';
import { comicCategories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-xl font-bold text-background-50 mb-4">
              韩漫网
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:text-accent-400 hover:bg-background-700 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:text-accent-400 hover:bg-background-700 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:text-accent-400 hover:bg-background-700 transition-colors"
                aria-label="QQ"
              >
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-100 mb-4 uppercase tracking-wide">
              漫画分类
            </h4>
            <div className="flex flex-col gap-2">
              {comicCategories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-100 mb-4 uppercase tracking-wide">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
              >
                首页
              </Link>
              <Link
                to="/category/completed"
                className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
              >
                已完结漫画
              </Link>
              <Link
                to="/category/ongoing"
                className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
              >
                连载中漫画
              </Link>
              <Link
                to="/about"
                className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-background-100 mb-4 uppercase tracking-wide">
              联系我们
            </h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-background-300">
                <i className="ri-mail-line mr-2"></i>
                {siteInfo.email}
              </p>
              <p className="text-sm text-background-300">
                <i className="ri-wechat-line mr-2"></i>
                {siteInfo.wechat}
              </p>
              <p className="text-sm text-background-300">
                <i className="ri-qq-line mr-2"></i>
                QQ群: {siteInfo.qq}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 韩漫网 - 韩漫全集与韩漫完结完整版 | 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">
                版权声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}